<div class="field">
    <p-dropdown styleClass="w-12" [panelStyleClass]="classStyle" id="every" [options]="params" [(ngModel)]="param"  optionValue="key" scrollHeight="300px"
    optionDisabled="inactive" (onChange)="onParamValueChange($event)" appendTo="body">
        <ng-template pTemplate="selectedItem">
            {{selectedLabel}}
        </ng-template>
    </p-dropdown>
</div>

